import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AppCheckCompatibleLanguage } from 'app/appLocales';
import { store } from 'app/store';
import MprcNotistackAction from 'components/MprcNotistackAction';
import { MprcRequestIndicator } from "components/MprcRequestIndicator";
import i18next from "i18next";
import { SnackbarProvider } from "notistack";
import { AppThemeProvider } from "providers/AppThemeProvider";
import { CoreApiProvider } from 'providers/CoreApiProvider';
import { SessionProvider, useSession } from "providers/SessionProvider";
import { ModalUserProfileProvider } from "providers/UserProfileProvider";
import { Suspense } from "react";
import { Provider } from 'react-redux';
import { Outlet, RouterProvider } from "react-router";
import { RootRouter } from "routes/RootRouter";
import ErrorBoundary from "views/ErrorBoundary";
import { SplashScreen } from "views/SplashScreen";



// Adaptação para React Router 6 com RouteData, uma vez que o createBrowserRouter não permite 'filhos' diretamente.
// Neste caso, o primeiro Route envolve as demais chamadas via propriedade Element.
const RootChildren = () => {
    const session = useSession();
    return <CoreApiProvider>
        <AppThemeProvider>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={session.uiCulture}>
                <SnackbarProvider
                    maxSnack={3}
                    autoHideDuration={3000}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    Components={
                        {
                            mprcAction: MprcNotistackAction,
                        }
                    }
                >
                    <ModalUserProfileProvider>
                        <Outlet />
                    </ModalUserProfileProvider>
                </SnackbarProvider>
            </LocalizationProvider>
        </AppThemeProvider>
    </CoreApiProvider>;
};

/**
 * Aplicação Principal
 */
export const App = () => {
    // Obtém o idioma do navegador (antes do login)
    let lang = i18next.language ?? navigator.language ?? "pt-BR";
    // Garante que o idioma seja suportado pelo sistema.
    lang = AppCheckCompatibleLanguage(lang);

    // Mensagem amigável para 'suspense'
    const suspenseMessage = lang == "pt-BR"
        ? "Aguarde..."
        : lang == "es-ES"
            ? "Espere...."
            : "Please wait...";

    // Inicializa
    return (
        <Suspense fallback={<MprcRequestIndicator type="suspense" message={suspenseMessage} />}>
            <ErrorBoundary>
                <Provider store={store}>
                    <SessionProvider initialLocale={lang} splashScreen={SplashScreen}>
                        <RouterProvider router={RootRouter(<RootChildren />)} />
                    </SessionProvider>
                </Provider>
            </ErrorBoundary>
        </Suspense>
    );
};
